module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-preview-toolbar-container"
  }, [_c('span', {
    staticClass: "box-preview-toolbar-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.visualizing')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "box-preview-toolbar"
  }, [_c('device-button', {
    attrs: {
      "device": "desktop"
    }
  }), _vm._v(" "), _c('device-button', {
    attrs: {
      "device": "tablet"
    }
  }), _vm._v(" "), _c('device-button', {
    attrs: {
      "device": "smartphone"
    }
  })], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7b98e79d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/devicebuttons/Main.vue
 ** module id = 871
 ** module chunks = 1
 **/